"use strict";

exports.__esModule = true;
exports.default = reducer;
function childMonitorState(props, state, action) {
  var child = props.children;
  return child.type.update(child.props, state, action);
}

function reducer(props) {
  var state = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var action = arguments[2];

  return {
    childMonitorState: childMonitorState(props, state.childMonitorState, action)
  };
}